import { I18n as AWSI18n } from 'aws-amplify';
import { LocalStorageKeys } from '@containers/App';
const LocalizationFileEN = require('../../public/locale-en.json');
const LocalizationFileES = require('../../public/locale-es.json');
const LocalizationFilePT_BR = require('../../public/locale-pt_br.json');

let localeId: string;
export default class I18n {
  static localeObj: any;
  constructor() {
    const locale = localStorage.getItem(LocalStorageKeys.LOCALE) || 'en';
    this.change(locale);
  }
  change(locale: string): string {
    switch (locale) {
      case 'pt-BR':
      case 'pt':
        AWSI18n.putVocabulariesForLanguage('pt', LocalizationFilePT_BR);
        localeId = 'pt-BR';
        break;
      case 'es':
        AWSI18n.putVocabulariesForLanguage('es', LocalizationFileES);
        localeId = 'es';
        break;
      default:
        AWSI18n.putVocabulariesForLanguage('en', LocalizationFileEN);
        localeId = 'en';
        break;
    }
    localStorage.setItem(LocalStorageKeys.LOCALE, localeId);
    AWSI18n.setLanguage(localeId);
    I18n.localeObj = I18n.getClientLocale();
    return localeId;
  }
  static l(alias: string) {
    if (!alias) {
      return '';
    }
    let res = AWSI18n.get(alias, `${alias}`);
    if (!res) {
      return `[${alias}]`;
    }


    const regex = res.match(/\{\{[a-z\.]+\}\}/ig);

    if (regex != null) {
      for (const key of regex) {
        res = res.replace(`${key}`, I18n.getClientLabel(key.replace('{{', '').replace('}}', '').trim()));
      }
    }
    return res;
  };

  static getClientLabel(key: string) {
    const newKey = key.replace('.', '_'); // replacing the locales values with '.' to '_' to match api values
    
    if(I18n.localeObj == null || I18n.localeObj == undefined){
      I18n.localeObj = I18n.getClientLocale();
    }
    if (I18n.localeObj) {
      if (I18n.localeObj.hasOwnProperty(newKey)) {
        return I18n.localeObj[newKey];
      }
    }
    return newKey;
  }

  static getClientLocale() {
    const ls = localStorage.getItem(LocalStorageKeys.CLIENT_LOCALES);
    let locales = null
    if (ls) {
      locales = JSON.parse(ls);
    } else {
    locales = [{
         "ehss_audited": "Auditado",
         "ehss_auditeds": "Auditados",
         "ehss_auditor": "Auditor",
         "ehss_auditors": "Auditores",
         "ehss_guest": "Visitante",
         "ehss_guests": "Visitantes",
         "ehss_manager": "Gestor",
         "ehss_managers": "Gestores",
         "ehss_process": "Auditoria",
         "ehss_process_manager": "Plano de Ação",
         "ehss_processes": "Auditorias",
         "global_product": "Produto",
         "global_products": "Produtos",
         "global_unit": "Unidade",
         "global_units": "Unidades",
         "global_user": "Usuário",
         "global_users": "Usuários",
         "global_workflow": "Fluxo de Tarefa",
         "global_workflows": "Fluxos de Tarefa",
         "id": "pt_br",
         "qa_manager": "Gestor",
         "qa_managers": "Gestores",
         "qa_process": "Processo",
         "qa_process_manager": "Gestão de Processos",
         "qa_processes": "Processos",
         "qafs_manager": "Gestor",
         "qafs_managers": "Gestores",
         "qafs_process": "Processo",
         "qafs_processes": "Processos"
       },
       {
         "ehss_audited": "Audited",
         "ehss_auditeds": "Auditeds",
         "ehss_auditor": "Auditor",
         "ehss_auditors": "Auditors",
         "ehss_guest": "Guest",
         "ehss_guests": "Guests",
         "ehss_manager": "Manager",
         "ehss_managers": "Managers",
         "ehss_process": "Audit",
         "ehss_process_manager": "Action Plan",
         "ehss_processes": "Audits",
         "global_product": "Product",
         "global_products": "Products",
         "global_unit": "Unit",
         "global_units": "Units",
         "global_user": "User",
         "global_users": "Users",
         "global_workflow": "Workflow",
         "global_workflows": "Workflows",
         "id": "en",
         "qa_manager": "Manager",
         "qa_managers": "Managers",
         "qa_process": "Process",
         "qa_process_manager": "Process Manager",
         "qa_processes": "Processes",
         "qafs_manager": "Manager",
         "qafs_managers": "Managers",
         "qafs_process": "Process",
         "qafs_processes": "Processes"
       },
       {
         "ehss_audited": "Auditado",
         "ehss_auditeds": "Auditados",
         "ehss_auditor": "Auditor",
         "ehss_auditors": "Auditores",
         "ehss_guest": "Visitante",
         "ehss_guests": "Visitantes",
         "ehss_manager": "Gerente",
         "ehss_managers": "Gerentes",
         "ehss_process": "Auditoría",
         "ehss_process_manager": "Gestión de procesos",
         "ehss_processes": "Auditorías",
         "global_product": "Producto",
         "global_products": "Productos",
         "global_unit": "Unidade",
         "global_units": "Unidades",
         "global_user": "Usuario",
         "global_users": "Usuarios",
         "global_workflow": "Flujo de trabajo",
         "global_workflows": "Flujos de trabajo",
         "id": "es",
         "qa_manager": "Gerente",
         "qa_managers": "Gerentes",
         "qa_process": "Proceso",
         "qa_process_manager": "Gestión de procesos",
         "qa_processes": "Procesos",
         "qafs_manager": "Gerente",
         "qafs_managers": "Gerentes",
         "qafs_process": "Proceso",
         "qafs_processes": "Procesos"
       }
     ];
    }

      const locale = locales.find((e: any) => e.id === I18n.getLocaleId());
      return locale


  }

  static getLocaleId = () => {
    switch (localeId) {
      case 'pt-BR':
      case 'pt':
        return 'pt_br';
      case 'en':
        return 'en';
      case 'es':
        return 'es';
      default:
        return 'en';
    }
  }

  static lApi = (response: string[]) => {
    return response.map((alias: string) => (I18n.l(`api.${alias}`) + (response.length > 1 ? '; ' : '')));
  };

  static getDateFormat = (locale: string = 'en') => {
    switch (locale) {
      case 'pt':
        return 'DD/MM/YYYY';
      default:
        return 'MM/DD/YYYY';
    }
  };
}